/**
 * @file 路由中语言处理-导航守卫
 */

import {
    find,
    getBrowserLanguage,
    getCookieLanguage,
    isSupport,
    resetHtmlDir,
    setAsyncLocale,
} from '@/locales/i18n'; // eslint-disable-line

import { locale } from '@/config/site';

export default [
    // 对支持的语言兼容大小写
    ({ path, query, hash }, from, next) => {
        const lang = path.split('/')[1];

        if (!isSupport(lang) && find(lang)) {
            return next({
                path: `/${find(lang)}/${path.split('/').slice(2).join('/') || ''}`,
                query,
                hash,

                // 这里使用 replace 是因为识别了老版本的语言（大写）
                // 那么应该让浏览器直接 replace ，不让用户再返回错误的链接
                replace: true,
            });
        }

        if (isSupport(lang)) {
            resetHtmlDir(lang);
        }

        return next();
    },

    // 链接中有语言，需要过滤/替换的语言
    !window.sfe.prerender ? ({ path, query, hash }, from, next) => {
        // fr-FR -> en，此处单独处理，是因为默认语言有兜底逻辑，不一定是en
        if (path.indexOf('/fr-FR') === 0) {
            return next({
                path: path.replace('/fr-FR', `/${locale}`),
                query,
                hash,
                replace: true,
            });
        }

        // zh-CN -> zh-MY（马来西亚）
        if (path.indexOf('/zh-CN') === 0) {
            return next({
                path: path.replace('/zh-CN', '/zh-MY'),
                query,
                hash,
                replace: true,
            });
        }

        return next();
    } : (a, from, next) => next(),

    // 识别语言
    ({ path, query, hash }, from, next) => {
        let lang = path.startsWith('/trade/spot') ? '' : path.split('/')[1];
        let newPath = path;

        // 如果连接中没有匹配的语言，则使用 localStorage中的lang > browser > default
        if (!isSupport(lang)) {
            // 如果lang输入错误，进行修正
            const langReg = /([A-Za-z]{1,})?(-)?([A-Za-z]{1,})?/;
            if (lang && langReg.test(lang)) {
                newPath = path.split('/').slice(2).join('/');
            }

            // 获取localStorage中的lang || 获取浏览器lang
            lang = getCookieLanguage() || getBrowserLanguage();

            // 语言不支持时，取默认语言: en
            lang = isSupport(lang) ? lang : locale;

            return next({
                path: `/${lang}/${newPath.replace(/^\/+/g, '')}`,
                query,
                hash,

                // 这里不能用 replace 是因为有的跳转路径是 /login 这种
                // 如果 replace 那么上面的跳转路径就不会产生历史记录
                // 这样会触发个问题，就是直接访问 / 时，会产生一条多余的历史记录，因为不确定是直接输入，还是 href="/"
                replace: true,
            });
        }

        // 设置语言
        return setAsyncLocale(lang || locale).then(() => next());
    },
];
